/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_MenuInputs */

const en_close_menu = /** @type {(inputs: Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close menu`)
};

const th_close_menu = /** @type {(inputs: Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปิดเมนู`)
};

const ja_close_menu = /** @type {(inputs: Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メニューを閉じる`)
};

const fr_close_menu = /** @type {(inputs: Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer le menu`)
};

const es_close_menu = /** @type {(inputs: Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar menú`)
};

const ru_close_menu = /** @type {(inputs: Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть меню`)
};

const zh_close_menu = /** @type {(inputs: Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭菜单`)
};

const vi_close_menu = /** @type {(inputs: Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đóng menu`)
};

/**
* | output |
* | --- |
* | "Close menu" |
*
* @param {Close_MenuInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const close_menu = /** @type {((inputs?: Close_MenuInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_MenuInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_close_menu(inputs)
	if (locale === "ja") return ja_close_menu(inputs)
	if (locale === "fr") return fr_close_menu(inputs)
	if (locale === "es") return es_close_menu(inputs)
	if (locale === "ru") return ru_close_menu(inputs)
	if (locale === "zh") return zh_close_menu(inputs)
	if (locale === "vi") return vi_close_menu(inputs)
	return en_close_menu(inputs)
});